import { UploadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Popconfirm, Row, Select, Table, Upload } from "antd";
import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { DeleteNotice, GetAllUnits, GetAllUsers, GetManagerNotices } from "../../RestAPI/dbo/StoryApi";
import axios from "axios";
import { BaseApi } from "../../RestAPI/dbo/BaseUrl";

const { Option } = Select;
function AddStory() {

    const [form] = Form.useForm();
    const [showMultiSelect, setShowMultiSelect] = useState(false);
    const [failUploadMessage, setFailUploadMessage] = useState("")
    const [units, setUnits] = useState<Array<{}>>([]);
    const [persons, setPersons] = useState<Array<{}>>([]);
    const [noticeList, setNoticeList] = useState<Array<{}>>([]);


    async function fechData() {
        setUnits(await GetAllUnits());
        setPersons(await GetAllUsers())
        setNoticeList(await GetManagerNotices())
    }



    useEffect(() => {
        fechData();
    }, []);
    const onFinish = (values: any) => {

        console.log(values)

        const formData = new FormData();
        formData.append("unit", values.unit);
        formData.append("text", values.text);
        formData.append("title", values.title);
        formData.append("time", values.time);
        formData.append("persons", values.persons);
        if (values.image && values.image[0]) {
            formData.append("image", values.image[0].originFileObj);
        }
        // if (values.persons) {
        //     formData.append("persons", JSON.stringify(values.persons));
        // }

        axios.post(BaseApi + "hr/AddStory?token=" + new Cookies().get("user").Token, formData).then(() => {
            setFailUploadMessage("عملیات با موفقیت انجام شد");
            fechData();
            form.resetFields()
        }).catch(() => {
            setFailUploadMessage("خطا");
        });
    };
    const handleUnitChange = (value: []) => {
        console.log(value);
        if (value.find(p => p === "spec")) {
            setShowMultiSelect(true);
        } else {
            setShowMultiSelect(false);
        }
    };
    const beforeUpload = (file: File) => {
        console.log(file)
        setFailUploadMessage("");
        const isImage = file.type.startsWith("image/");
        const isLt2M = file.size / 1024 / 1024 <= 2; // محدودیت 2 مگابایت
        if (!isImage) {
            setFailUploadMessage("فقط می‌توانید فایل‌های تصویری آپلود کنید.")
            return;
        }

        if (!isLt2M) {
            setFailUploadMessage('حجم فایل باید کمتر از 2 مگابایت باشد!');
        }
        return isLt2M || Upload.LIST_IGNORE;
    };

   async function handleDelete(ID: any) {
    console.log(ID)
       await DeleteNotice(ID);
       fechData();
    } 

    const columns = [
        {
            title: 'عملیات',
            dataIndex: 'ID',
            key: 'ID',
            render: (record: any) =>
                <Popconfirm title="برای حذف اطمینان دارید?" onConfirm={() => handleDelete(record)}>
                    <a>حذف</a>
                </Popconfirm>
        },
        {
            title: 'عنوان',
            dataIndex: 'Title',
            key: 'Title',
        },
        {
            title: 'متن',
            dataIndex: 'Text',
            key: 'Text',
        },
        {
            title: 'لیست افراد',
            dataIndex: 'UserCanSee',
            key: 'UserCanSee',
        },
        {
            title: 'مشاهده کرده',
            dataIndex: 'UserSeen',
            key: 'UserSeen',
        },
    ]
    return (
        <>
            {/* <h3>به زودی</h3> */}

            <Card title="ثبت اطلاعیه" style={{ margin: 10 }}>

                <Row justify="center" style={{ padding: 20 }}>
                    <Col xs={24} sm={16} lg={12}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            style={{ background: "#fff", padding: 20, borderRadius: 8 }}
                        >
                            <Form.Item
                                name="unit"
                                label="انتخاب واحد"
                                rules={[{ required: true, message: "لطفاً یک واحد انتخاب کنید!" }]}
                            >
                                <Select
                                    placeholder="واحد را انتخاب کنید"
                                    mode="multiple"
                                    onChange={handleUnitChange}
                                >
                                    {units.map((unit: any) => (
                                        <Option key={unit.ID} value={unit.ID}>{unit.Name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            {showMultiSelect && (
                                <Form.Item
                                    name="persons"
                                    label="انتخاب اشخاص"
                                    rules={[{ required: true, message: "لطفاً اشخاص را انتخاب کنید!" }]}
                                >
                                    <Select
                                        mode="multiple"
                                        placeholder="اشخاص مورد نظر را انتخاب کنید"
                                    >
                                        {persons.map((p: any) => (
                                            <Option key={p.ID} value={p.ID}>{p.Name}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            )}

                            <Form.Item
                                name="time"
                                label="اعتبار اعلان(روز)"
                                rules={[{ required: true, message: "لطفا اعتبار اعلان را مشخص کنید" }]}
                            >
                                <Select
                                >
                                    <Option value="1">یک روز</Option>
                                    <Option value="2">دو روز</Option>
                                    <Option value="3">سه روز</Option>
                                    <Option value="7">یک هفته</Option>
                                    <Option value="14">دو هفته</Option>
                                    <Option value="31">یک ماه</Option>
                                    <Option value="62">دو ماه</Option>
                                    <Option value="181">شش ماه</Option>
                                    <Option value="365">یک سال</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item
                                name="title"
                                label="عنوان"
                                rules={[{ required: true, message: "عنوان را وارد کنید" }]}>
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="text"
                                label="متن"
                                rules={[{ required: true, message: "لطفاً متن را وارد کنید!" }]}
                            >
                                <Input.TextArea rows={4} placeholder="متن خود را وارد کنید" />
                            </Form.Item>

                            <Form.Item
                                name="image"
                                label="آپلود تصویر"
                                valuePropName="fileList"
                                
                                getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
                            >
                                <Upload beforeUpload={beforeUpload} name="file" listType="picture" maxCount={1}  >
                                    <Button icon={<UploadOutlined />}>آپلود تصویر-کمتر از 2 مگابایت</Button>
                                </Upload>

                            </Form.Item>

                            <h4 style={{ color: "red" }}>{failUploadMessage}</h4>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" block>
                                    ارسال
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Card>


            <Card
                title="لیست اطلاعیه ها"
                style={{ margin: 10 }}
            >
                <Table
                    bordered
                    dataSource={noticeList}
                    columns={columns}
                    scroll={{ x: 'max-content' }}
                />
            </Card>

        </>
    )
}

export default AddStory;

